import gql from 'graphql-tag';

export default gql`
  query getProductFeedbacks($input: GetProductFeedbacksInput) {
    getProductFeedbacks(input: $input) {
      data {
        id
        rating
        userName
        orderDate
        deliveryId
        status
        comment
        storeName
        isAnonymous
        productName
        media {
          type
          url
          name
          isPrimary
        }
      }
      total
    }
  }
`;
